import { HttpClient } from '@angular/common/http';
import { FOLDER_PATH_HEADER_NAME } from '@pages/monitoring/monitoring.interceptor';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ErrorMonitoringService = /** @class */ (function () {
    function ErrorMonitoringService(_http) {
        this._http = _http;
    }
    ErrorMonitoringService.prototype.dismiss = function (entityIds, fqn) {
        var _a;
        var endpoint = "/monitoring/ErrorLogsMonitoring/DismissErrorsBulk";
        return this._http.post(endpoint, entityIds, fqn
            ? { headers: (_a = {}, _a[FOLDER_PATH_HEADER_NAME] = fqn, _a) }
            : undefined);
    };
    ErrorMonitoringService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ErrorMonitoringService_Factory() { return new ErrorMonitoringService(i0.ɵɵinject(i1.HttpClient)); }, token: ErrorMonitoringService, providedIn: "root" });
    return ErrorMonitoringService;
}());
export { ErrorMonitoringService };
